'use es6';

import Sections from 'DesignData/enums/hublDocs/Sections';
export const SECTIONS_ORDER = Object.keys(Sections);
export const PUBLIC_DOCS_LINK_BASE = 'http://designers.hubspot.com/docs/hubl';